import {
  Button,
  Heading,
  Icon,
  LoadingIcon,
  Stack,
  Text,
} from '@eluve/components';

// In-flight fill state only. The finished PDF persists as a document and is
// rendered by PdfDocumentTabContent, so there's no 'ready' state here.
export type PdfFillState =
  | { status: 'preparing'; templateId: string; title: string }
  | { status: 'error'; templateId: string; title: string; message?: string };

export type PdfFillTabContentProps = {
  fill: PdfFillState;
  onStop: () => void;
  onRetry: () => void;
};

export const PdfFillTabContent: React.FC<PdfFillTabContentProps> = ({
  fill,
  onStop,
  onRetry,
}) => {
  if (fill.status === 'preparing') {
    return (
      <Stack fullHeight justify="center" align="center" gap={4}>
        <Stack align="center" gap={4}>
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-bg-tertiary">
            <Icon name="FileText" size="2xl" className="text-text-secondary" />
          </div>
          <Stack align="center" gap={2}>
            <Heading size="xl">Preparing your PDF</Heading>
            <Text color="secondary" className="text-center">
              This PDF form will be filled using your session data.
            </Text>
            <Text size="sm" color="tertiary" className="text-center">
              You can switch tabs in the meantime — we'll keep working in the
              background.
            </Text>
          </Stack>
          <Stack align="center" gap={2}>
            <Button disabled>
              <LoadingIcon />
              Preparing PDF…
            </Button>
            <Button variant="ghost" size="sm" onClick={onStop}>
              Stop generating
            </Button>
          </Stack>
        </Stack>
      </Stack>
    );
  }

  return (
    <Stack fullHeight justify="center" align="center" gap={4}>
      <Stack align="center" gap={4}>
        <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-bg-tertiary">
          <Icon name="AlertCircle" size="2xl" className="text-text-negative" />
        </div>
        <Stack align="center" gap={2}>
          <Heading size="xl">Something went wrong filling this form.</Heading>
          {fill.message && (
            <Text color="secondary" className="text-center">
              {fill.message}
            </Text>
          )}
        </Stack>
        <Stack align="center" gap={2}>
          <Button onClick={onRetry}>
            <Icon name="RotateCcw" size="auto" />
            Try again
          </Button>
          <Button variant="ghost" size="sm" onClick={onStop}>
            Close
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
